import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./OrderDetails.module.scss";

import { useGlobalStore } from "../stores/globalStore";

function OrderDetails() {
  const showShippingInfo = useGlobalStore((state) => state.showShippingInfo);
  const { t } = useTranslation();

  return (
    <>
      <ul className={styles.orderList}>
        <li className={styles.listItem}>
          <div className={styles.imageWrapper}>
            <img
              src="https://stripe-camo.global.ssl.fastly.net/c25a949b6f1ffabee9af1a5696d7f152325bdce2d1b926456d42994c3d91ad78/68747470733a2f2f66696c65732e7374726970652e636f6d2f6c696e6b732f666c5f746573745f67625631776635726a4c64725a635858647032346d643649"
              alt=""
              loading="lazy"
            />
          </div>

          <div className={styles.info}>
            <div className={styles.productName}>productName</div>
            <div className={styles.productPrice}>$20.00</div>
          </div>
        </li>

        <li className={styles.listItem}>
          <div className={styles.imageWrapper}>
            <img
              src="https://stripe-camo.global.ssl.fastly.net/d4d32b3216cdb09a5749e32214a8f37dbe0785affd4234c80471cebd74e8c076/68747470733a2f2f66696c65732e7374726970652e636f6d2f6c696e6b732f4d44423859574e6a64463878534559775a317044536c4978626d7470597a4a5866475a735833526c63335266596b746c4e6d5a3565564e71526d777a526e6856656e49785a455645534570543030334a377239327551"
              alt=""
              loading="lazy"
            />
          </div>

          <div className={styles.info}>
            <div className={styles.productName}>productName</div>
            <div className={styles.productPrice}>$30.00</div>
          </div>
        </li>
      </ul>

      <div className={styles.footer}>
        {showShippingInfo ? (
          <>
            <div className={styles.subTotal}>
              <span className={styles.total}>{t("mainPage.subTotal")}</span>
              <span className={styles.sum}>$50.00</span>
            </div>

            <div className={styles.shipping}>
              <span className={styles.header}>{t("mainPage.shipping")}</span>
              <span className={styles.sum}>$5.00</span>
            </div>

            <div className={styles.total}>
              <span className={styles.header}>{t("mainPage.total")}</span>
              <span className={styles.sum}>$55.00</span>
            </div>
          </>
        ) : (
          <>
            <div className={styles.total}>
              <span className={styles.header}>{t("mainPage.total")}</span>
              <span className={styles.sum}>$50.00</span>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default OrderDetails;
